import {LINES_REQUEST, LINES_SHOW, LINES_EDIT, LINES_CLEAR, LINES_FAIL, LINES_COMPLETE} from "../store/config";

const linesInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:''
	},
	edit: {},
	permissions: [],
	error: undefined
}

const lines = (state = linesInit, action) => {
	switch (action.type) {
		case LINES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case LINES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case LINES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case LINES_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case LINES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case LINES_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default lines;


// WEBPACK FOOTER //
// ./src/reducers/lines.js